/** Activity display only: omit cents at $1,000 without rounding the amount up. */
export function formatActivityUsd(usd: number): string {
	if (!Number.isFinite(usd)) return '0.00'
	return (usd >= 1000 ? Math.trunc(usd).toString() : usd.toFixed(2))
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
